module.exports = __webpack_public_path__ + "static/media/test.4c018825.svg";